import { render } from "./Eula.vue?vue&type=template&id=db8c4da4&scoped=true&ts=true"
import script from "./Eula.vue?vue&type=script&lang=ts"
export * from "./Eula.vue?vue&type=script&lang=ts"

import "./Eula.vue?vue&type=style&index=0&id=db8c4da4&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8c4da4"]])

export default __exports__